import React from "react";
import MyopiaSimulatorTest from "components/MyopiaSimulatorTest/MyopiaSimulatorTest";
import { AAVText, EyeIcon } from "../components/SVG/SVGComponents";

function MyopiaSimulator() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const renderDisclaimer = () => {
    return (
      <p>
        Disclaimer: For advice and further information about nearsightedness you
        should consult an eye care professional. This Vision Simulator should be
        treated as information only and does not represent advice. The images
        presented are artistic interpretations of nearsightedness as experienced
        without glasses or contact lenses.
      </p>
    );
  };

  return (
    <div className="page-container">
      <div className="sticky-header">
        <EyeIcon />
        <AAVText />
      </div>
      <div className="main-content">
        <section>
          <MyopiaSimulatorTest />
        </section>
        <section className="text-center">
          <p>
            Click and slide target below to show uncorrected vision at different
            Rx levels (in diopters)
          </p>
        </section>
      </div>

      <div className="disclaimer-container">
        <section className="disclaimer-container__content">
          {renderDisclaimer()}
        </section>
      </div>
    </div>
  );
}

export default MyopiaSimulator;
